import { Injectable } from '@angular/core';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { DrillingHoleInfo } from './drilling-hole-info';
import { RangeOnLineConnectionUtils } from '../range-on-line-connection-utils';
import { DrillingHoleUtils } from './drilling-hole-utils';
import { ContainerService } from '../../container.service';

@Injectable({
  providedIn: 'root'
})
export class DrillingHoleInfoFactory {

  constructor(
    private containerService: ContainerService,
  ) { }

  public createForRefresh(childUsage: ArticleUsageVO, childArticle: ArticleVO) {
    const childContainer = this.containerService.findArticleContainerInGlobal(childUsage.id);
    const drillingHoleInfo: DrillingHoleInfo = new DrillingHoleInfo();
    drillingHoleInfo.usageId = childUsage.id;
    drillingHoleInfo.positionOffset = RangeOnLineConnectionUtils.getHalfStretchLengthInAwayUnits();
    drillingHoleInfo.position = -childContainer.position.x;
    drillingHoleInfo.shapeType = DrillingHoleUtils.getDrillingHoleShapeTypeByArticle(childArticle);
    drillingHoleInfo.size = DrillingHoleUtils.getDrillingHoleSizeByArticle(childArticle);
    return drillingHoleInfo;
  }
}
